import { View } from "react-native";
import React from "react";
import { Divider, Text } from "@ui-kitten/components";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { useAppSelector } from "hooks/useAppSelector";
import i18n from "plugins/localization";
import { useFetchTenantConfigurationQuery } from "queries/configuration.queries";

const ContactUs = () => {
  const { data: tenantConfig } = useFetchTenantConfigurationQuery();
  const theme = useAppSelector((state) => state.theme.theme);

  return (
    <>
      <Text category="h6">{i18n.t("screens.Barcode.contactUs")}</Text>
      <Divider style={{ marginVertical: 10 }} />
      <View>
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <MaterialCommunityIcons
            name="phone"
            size={24}
            color={theme === "dark" ? "white" : "black"}
          ></MaterialCommunityIcons>
          <Text category="h6" selectable>
            {tenantConfig?.supportPhone || "N/A"}
          </Text>
        </View>
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <MaterialCommunityIcons
            name="email"
            size={24}
            color={theme === "dark" ? "white" : "black"}
          ></MaterialCommunityIcons>
          <Text category="h6" selectable>
            {tenantConfig?.supportEmail || "N/A"}
          </Text>
        </View>
      </View>
    </>
  );
};

export default ContactUs;
